import Box from '@mui/joy/Box';

// Stable short identifiers fit the existing field; old saved emoji remain readable.
export const FOLDER_ICONS = [
  ['', 'Без значка'], ['folder', 'Папка'], ['case', 'Работа'],
  ['measure', 'Обмер'], ['ruler', 'Чертежи'], ['team', 'Команда'],
  ['home', 'Объект'], ['star', 'Избранное'], ['fire', 'Важное'],
  ['check', 'Готово'], ['chat', 'Переписка'], ['phone', 'Клиенты'],
  ['ticket', 'Поддержка'], ['mention', 'Упоминания'],
];
const LEGACY = {
  '📁': 'folder', '💼': 'case', '📐': 'measure', '📏': 'ruler',
  '🧑‍💼': 'team', '🏠': 'home', '⭐': 'star', '🔥': 'fire',
  '✅': 'check', '💬': 'chat', '📞': 'phone', '🎫': 'ticket',
};
export const folderIconKey = value => LEGACY[value] || (
  FOLDER_ICONS.some(([key]) => key === value) ? value : 'folder'
);
const colors = {
  folder: '#7255e8', case: '#986436', measure: '#7255e8', ruler: '#7255e8',
  team: '#337aaf', home: '#278d78', star: '#b98619', fire: '#d66e30',
  check: '#278d78', chat: '#7255e8', phone: '#337aaf', ticket: '#337aaf', mention: '#7255e8',
};
const drawings = {
  folder: <><path d="M3 7a2 2 0 0 1 2-2h5l2 3h7a2 2 0 0 1 2 2v9H3Z" fill="currentColor" opacity=".15" /><path d="M3 7a2 2 0 0 1 2-2h5l2 3h7a2 2 0 0 1 2 2v9H3Z" /><path d="M3 10h18" /></>,
  case: <><rect x="3" y="7" width="18" height="13" rx="2" fill="currentColor" opacity=".15" /><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7V4h8v3M3 12a25 25 0 0 0 18 0M10 12v3h4v-3" /></>,
  measure: <><path d="M4 3v18h17Z" fill="currentColor" opacity=".15" /><path d="M4 3v18h17ZM8 12v5h5M4 8h2M4 12h2M4 16h2" /></>,
  ruler: <><path d="m4 15 11-11 5 5L9 20Z" fill="currentColor" opacity=".15" /><path d="m4 15 11-11 5 5L9 20ZM13 6l2 2M10 9l2 2M7 12l2 2" /></>,
  team: <><circle cx="9" cy="8" r="3" fill="currentColor" opacity=".15" /><circle cx="9" cy="8" r="3" /><path d="M3 20v-3a6 6 0 0 1 12 0v3ZM16 5a3 3 0 0 1 0 6M18 14a5 5 0 0 1 3 5" /></>,
  home: <><path d="m3 11 9-8 9 8M5 10v11h14V10" /><path d="M9 21v-8h6v8" fill="currentColor" opacity=".15" /></>,
  star: <><path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9Z" fill="currentColor" opacity=".15" /><path d="m12 3 2.8 5.7 6.2.9-4.5 4.4 1.1 6.2-5.6-3-5.6 3 1.1-6.2L3 9.6l6.2-.9Z" /></>,
  fire: <><path d="M13 3c1 6 6 6 6 11a7 7 0 0 1-14 0c0-3 2-5 4-7v5c2-2 4-5 4-9Z" fill="currentColor" opacity=".15" /><path d="M13 3c1 6 6 6 6 11a7 7 0 0 1-14 0c0-3 2-5 4-7v5c2-2 4-5 4-9ZM11 15l-1 3 3 1 1-3" /></>,
  check: <><circle cx="12" cy="12" r="9" fill="currentColor" opacity=".15" /><circle cx="12" cy="12" r="9" /><path d="m8 12 3 3 5-6" /></>,
  chat: <><path d="M4 4h16v13H9l-5 4Z" fill="currentColor" opacity=".15" /><path d="M4 4h16v13H9l-5 4ZM8 9h8M8 13h5" /></>,
  phone: <><path d="m6 3 4 5-3 3a16 16 0 0 0 6 6l3-3 5 4-2 3C11 22 2 13 3 5Z" fill="currentColor" opacity=".15" /><path d="m6 3 4 5-3 3a16 16 0 0 0 6 6l3-3 5 4-2 3C11 22 2 13 3 5Z" /></>,
  ticket: <><path d="M3 5h18v5a2 2 0 0 0 0 4v5H3v-5a2 2 0 0 0 0-4Z" fill="currentColor" opacity=".15" /><path d="M3 5h18v5a2 2 0 0 0 0 4v5H3v-5a2 2 0 0 0 0-4ZM15 5v3m0 3v2m0 3v3" /></>,
  mention: <><circle cx="12" cy="12" r="4" fill="currentColor" opacity=".15" /><circle cx="12" cy="12" r="4" /><path d="M16 8v6a2 2 0 0 0 4 0v-2a8 8 0 1 0-3.5 6.6" /></>,
};
export default function FolderIcon({ value = 'folder', size = 20, sx }) {
  const key = folderIconKey(value);
  return <Box component="svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"
    fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round"
    sx={{ width: size, height: size, display: 'block', flexShrink: 0, color: colors[key] || 'text.tertiary', ...sx }}>
    {drawings[key] || <path d="M6 12h12" />}
  </Box>;
}
